<div v-if="is_open" class="settings-modal-backdrop" @click.self="close_modal">
    <div v-if="load_error || save_error || save_success" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div v-if="load_error" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ load_error }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_load_error"></button>
            </div>
        </div>

        <div v-if="save_error" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ save_error }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_save_error"></button>
            </div>
        </div>

        <div v-if="save_success" class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-success" role="status">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-check2-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ save_success }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_save_success"></button>
            </div>
        </div>
    </div>

    <div class="settings-modal-card glass-card rounded-4 tariff-rates-modal-card p-0">
        <div class="d-flex justify-content-between align-items-start gap-3 p-3 border-bottom border-white border-opacity-10">
            <div>
                <h5 class="text-white text-xs fw-bold mb-1">{{ modal_title }}</h5>
                <p class="text-white-50 text-xs fw-semibold mb-0">{{ modal_subtitle }}</p>
            </div>

            <button
                type="button"
                class="btn btn-sm btn-outline-light rounded-circle settings-modal-close text-xs"
                @click="close_modal"
                aria-label="Close tariff rates modal"
            >
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <div v-if="is_loading" class="m-3 border border-white border-opacity-10 rounded-4 p-4 text-white-50">
            <div class="d-flex align-items-center gap-3">
                <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
                <div>
                    <p class="text-white fw-semibold mb-1">Loading tariff rates</p>
                    <p class="text-white-50 text-xs mb-0">We are fetching the detailed rates linked to this tariff book.</p>
                </div>
            </div>
        </div>

        <div v-else class="tariff-rates-modal-body p-3">
            <TariffRatesEditTab
                :rate_rows="rate_rows"
                :context="context"
                :tariff_book="tariff_book"
                :is_saving="is_saving"
                :supports_rate_updates="supports_rate_updates"
                :format_date="format_date"
                :get_metric_rows="get_metric_rows"
                @update-effective="update_rate_effective_field"
                @update-metric="update_metric_value"
            />
        </div>

        <div class="tariff-rates-modal-footer d-flex justify-content-end gap-2 p-3 border-top border-white border-opacity-10">
            <button type="button" class="btn button-outline btn-outline-light rounded-3 d-flex align-items-center gap-1 settings-button-shape" @click="close_modal">
                <span class="text-xs">Close</span>
            </button>

            <button
                type="button"
                class="btn-primary rounded-3 d-flex align-items-center gap-1 settings-button-shape"
                :disabled="is_saving || !supports_rate_updates || !rate_rows.length"
                @click="save_rate(rate_rows[0])"
            >
                <span class="text-xs">{{ supports_rate_updates ? (is_saving ? "Saving..." : "Save changes") : "Save unavailable" }}</span>
            </button>
        </div>
    </div>
</div>
